import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=37c9fded&"
import script from "./errorPage.js?vue&type=script&lang=js&"
export * from "./errorPage.js?vue&type=script&lang=js&"
import style0 from "./errorPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports